export default "__VITE_ASSET__CMFPhwpJ__"